import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import {
  B2BGetOrdersReq,
  GetB2BOutboundDocumentDetailReq,
  GetB2BOutboundDocumentDetailRes,
  GetExpectedAllocationReq,
  GetExpectedAllocationRes,
  GetOrdersReq,
  OrderItem,
  OrdersMenuCode,
  RunStandardOrderCutoffReq,
} from '@/services/outbound/outboundWaitingStatus/types'

// 주문조회 API 는 gi23 과 gi26 이 같이 부른다 — 감사 로그 화면코드를 헤더로 보낸다(LOGISPRD-15993)
export const getOrders = (params: GetOrdersReq, menuCode: OrdersMenuCode) =>
  request.post<ApiResponseV2<ApiPageResponse<OrderItem>>, GetOrdersReq>(`/api/v1/get-orders`, params, menuCodeHeaders(menuCode))

export const getExpectedAllocaton = (params: GetExpectedAllocationReq) =>
  request.post<ApiResponseV2<GetExpectedAllocationRes>, GetExpectedAllocationReq>(`/api/v1/get-expected-allocation`, params)

export const getB2BOrders = (params: ApiPaginationReq<B2BGetOrdersReq>) =>
  request.post<ApiResponseV2<ApiPageResponse<OrderItem>>, B2BGetOrdersReq>(`/api/v1/get-b2b-outbound-documents`, params)

export const getB2BOutboundDocumentDetail = (params: ApiPaginationReq<GetB2BOutboundDocumentDetailReq>) =>
  request.get<ApiResponseV2<ApiPageResponse<GetB2BOutboundDocumentDetailRes>>, GetB2BOutboundDocumentDetailReq>(
    `/api/v1/get-b2b-outbound-document/${params.outboundDocumentNumber}?page=${params.page}&size=${params.size}`,
  )

export const runStandardOrderCutoff = (params: RunStandardOrderCutoffReq) =>
  request.post<ApiResponseV2, RunStandardOrderCutoffReq>(`/api/v1/run-standard-order-cutoff`, params)
